import { IconDefinition } from '@fortawesome/pro-light-svg-icons'

import { ModalType } from '@espoon-voltti/react-components/components'

export type ModalAction = 'NOOP' | 'CLOSE'

export interface ModalProps {
  title: React.ReactNode
  icon: IconDefinition
  type: ModalType
  text: React.ReactNode
  dataQa: string
  content: React.ReactNode
  stack: number
  onConfirm: () => ModalAction
  onCancel?: () => ModalAction
  confirmButtonLabel: React.ReactNode
  cancelButtonLabel: React.ReactNode
  className?: string
}

export interface ContextProps extends Partial<ModalProps> {
  icon: ModalProps['icon']
  type: ModalProps['type']
  confirmButtonLabel: ModalProps['confirmButtonLabel']
  cancelButtonLabel: ModalProps['cancelButtonLabel']
}

export interface UserConfig
  extends Partial<Omit<ModalProps, 'onConfirm' | 'onCancel'>> {
  id?: string
  title: ModalProps['title']
}

export interface ModalUserConfig extends Partial<ModalProps> {
  title: ModalProps['title']
}

export const setDefaultModalConfig = (config: ContextProps): ModalProps => ({
  title: null,
  text: null,
  content: null,
  dataQa: 'promptModal',
  stack: 1,
  onConfirm: () => 'CLOSE',
  ...config
})

export const closeWithSideEffect =
  (sideEffect: () => any) => (): ModalAction => {
    sideEffect()
    return 'CLOSE'
  }

export const noopWithSideEffect =
  (sideEffect: () => any) => (): ModalAction => {
    sideEffect()
    return 'NOOP'
  }
